module.exports = __webpack_public_path__ + "static/media/work (1).b3c67da6.jpg";